import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getSelectTestIds = createTestIds('select', ['control', ...elements] as const);
